/* eslint-disable react/prop-types */
/* eslint-disable react/react-in-jsx-scope */
import {
    Box,
    Divider,
    LinearProgress,
    Tooltip,
    Typography,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { styled } from "@mui/material/styles";
import { useState, useEffect } from "react";

const ReelsProgress = styled(LinearProgress)(() => ({
    height: 8,
    borderRadius: 4,
    width: "100%",
    backgroundColor: "#F0F0F0",
    "& .MuiLinearProgress-bar": {
        borderRadius: 4,
        background: "#f444f0",
    },
}));

const Followers = ({ data }) => {
    // Initialize state first (before any conditional returns)
    const [selectedDate, setSelectedDate] = useState(null);

    // Set initial selected date when data is available using useEffect
    useEffect(() => {
        if (data?.raw_data?.values?.[0] && !selectedDate) {
            setSelectedDate(data.raw_data.values[0]);
        }
    }, [data, selectedDate]);

    // Add null checks after hooks
    if (
        !data ||
        !data.raw_data ||
        !Array.isArray(data.raw_data.values) ||
        data.raw_data.values.length === 0
    ) {
        return null;
    }

    return (
        <Box>
            <Box
                display={"flex"}
                alignItems={"center"}
                gap={0.5}
                margin={"3rem 0 0 0"}
            >
                <Typography variant="h6">Followers</Typography>

                <Tooltip title={data.raw_data.description} arrow>
                    {/* <Button sx={{ padding: 0 }}> */}
                    <InfoIcon fontSize="small" sx={{ margin: 0 }} />
                    {/* </Button> */}
                </Tooltip>
            </Box>

            <Box
                display={"flex"}
                alignItems={"center"}
                margin={"0.5rem 0 0 0"}
                gap={"1rem"}
                justifyContent={"space-around"}
            >
                <Box width={"30%"}>
                    <Typography variant="h6">{data.total_followers}</Typography>
                    <Typography component="p" fontSize={"0.85rem"}>
                        Total followers
                    </Typography>
                </Box>

                <Divider orientation="vertical" flexItem />

                <Box width={"60%"}>
                    <Typography variant="h6">By Date</Typography>

                    <Box
                        sx={{
                            width: "100%",
                            maxWidth: 500,
                            pt: 1.5,
                        }}
                    >
                        <Box
                            display={"flex"}
                            gap={"1rem"}
                            width={"100%"}
                            overflow={"auto"}
                            sx={{ scrollbarWidth: "none" }}
                        >
                            {data.raw_data.values
                                .filter((stat) => stat && stat.end_time) // Filter out null/undefined values
                                .map((stat, index) => {
                                    return (
                                        <Box
                                            key={index}
                                            padding={"0.5rem"}
                                            borderRadius={"0.8rem"}
                                            minWidth={"max-content"}
                                            color={
                                                selectedDate?.end_time ===
                                                stat.end_time
                                                    ? "#fff"
                                                    : "#000"
                                            }
                                            sx={{
                                                background:
                                                    selectedDate?.end_time ===
                                                    stat.end_time
                                                        ? "#f444f0"
                                                        : "#F0F0F0",
                                                cursor: "pointer",
                                            }}
                                            fontSize={"0.8rem"}
                                            onClick={() =>
                                                setSelectedDate(stat)
                                            }
                                        >
                                            {new Date(stat.end_time).getDate() +
                                                " " +
                                                new Date(
                                                    stat.end_time
                                                ).toLocaleString("default", {
                                                    month: "short",
                                                })}
                                        </Box>
                                    );
                                })}
                        </Box>
                        <Box
                            margin={"1.5rem 0 0 0"}
                            display={"flex"}
                            alignItems={"center"}
                        >
                            <Typography
                                sx={{
                                    color: "black",
                                    fontWeight: 500,
                                    minWidth: "max-content",
                                    fontSize: "0.85rem",
                                    textTransform: "capitalize",
                                    wordBreak: "break-word",
                                }}
                                component={"p"}
                            >
                                Online Followers
                            </Typography>
                            <Box sx={{ flexGrow: 1, mx: 2 }}>
                                <ReelsProgress
                                    variant="determinate"
                                    value={
                                        selectedDate?.value &&
                                        data.total_followers
                                            ? (selectedDate.value /
                                                  data.total_followers) *
                                              100
                                            : 0
                                    }
                                />
                            </Box>
                            <Typography
                                sx={{
                                    color: "black",
                                    fontWeight: 500,
                                    width: "3rem",
                                    textAlign: "right",
                                }}
                            >
                                {selectedDate?.value && data.total_followers
                                    ? (
                                          (selectedDate.value /
                                              data.total_followers) *
                                          100
                                      ).toFixed(1)
                                    : "0.0"}
                                %
                            </Typography>
                        </Box>
                        <Typography
                            fontSize={"0.7rem"}
                            textAlign="center"
                            marginTop={"1.4rem"}
                        >
                            <span style={{ color: "#f444f0", fontWeight: 600 }}>
                                ● &nbsp;
                            </span>
                            Followers
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default Followers;
